import React from 'react';
import PropTypes from 'prop-types';
import HouseholdSectionPicker
  from 'Components/Flyouts/HouseholdInfo/Sections/Section/HouseholdSectionPicker/HouseholdSectionPicker';
import HouseholdSectionBillingServiceLevelSummary from './HouseholdSectionBillingServiceLevelSummary/HouseholdSectionBillingServiceLevelSummary';
import HouseholdSectionBillingPicker from './HouseholdSectionBillingPicker/HouseholdSectionBillingPicker';


const BillingSection = ({ householdResource }) => {
  return (
    <HouseholdSectionPicker label="Billing" resource={householdResource}>
      <HouseholdSectionBillingServiceLevelSummary householdResource={householdResource} />
      <HouseholdSectionBillingPicker householdResource={householdResource} />
    </HouseholdSectionPicker>
  );
};
BillingSection.propTypes = {
  householdResource: PropTypes.object.isRequired,
};

export default BillingSection;
